import { useRef } from 'react';
import fetch from 'node-fetch';

import { getEnvironmentSettings } from '@pb/services';

import { TLoggedInUser } from '.';

export class AuthorisationService {
    constructor(private apiBaseUrl: string) {}

    async getLoggedInUser(): Promise<TLoggedInUser> {
        const result = await fetch(
            `${this.apiBaseUrl}/users-api/v1/user/getUserDetails`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Cache': 'no-cache',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                // @ts-ignore
                credentials: 'include',
            }
        );

        if (result.status >= 400) {
            throw result;
        }
        return await result.json();
    }
}

export function useAuthorisationService(apiBaseUrl: string) {
    const authorisationService = useRef(new AuthorisationService(apiBaseUrl));

    return authorisationService.current;
}

export async function logOut() {
    const { baseUrl } = getEnvironmentSettings();

    await fetch(`${baseUrl}/api/AccountApi/LogOut`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest',
        },
        // @ts-ignore
        credentials: 'include',
    });

    window.location.href = `${baseUrl}/Account/Login`;
}
